export const greetingText = `Hello! I'm Assistimo, your personal AI-powered assistant.

Ask me any questions you have and I'll try my best to answer!

Please be aware that, as this is a beta programme, chat history will be logged to support future performance improvements.`;

type SuggestedPrompt = { id: string; text: string };

export const suggestedPrompts: SuggestedPrompt[] = [
  { id: "open-cases", text: "Show my open cases" },
  { id: "jobs-due-this-week", text: "Which jobs are due this week?" },
  { id: "my-tasks", text: "What tasks are assigned to me?" },
  { id: "expiring-insurance-policies", text: "Which insurance policies expire in the next 3 months?" },
];
